import React, { useState, useEffect, useRef } from "react";
import uploadIcon from "../assets/images/Icon feather-upload-cloud.png"

/**
 * 
 * @param {String} HtmlFor
 * @param {String} FileError
 * @param {String} CAPTION
 * @param {Function} OnSelectFile
 * @param {Function} UploadFile
 * @param {String} Accept @default '.csv, .txt'
 * @param {String} Color 
 * @returns 
 */
const FileUpload = ({ HtmlFor, FileError, CAPTION, OnSelectFile, UploadFile, Accept = ".csv, .txt", Color, ButtonText = "Convert File" }) => {

    const [fileName, setFileName] = useState("");
    const [fileError, setFileError] = useState("");
    const [dragging, setDragging] = useState(false);
    const fileInput = useRef(null);

    useEffect(() => {
        setFileError(FileError);
    }, [FileError]);

    function onSelectFile(e, isDrop) {
        let file = isDrop ? e.dataTransfer.files[0] : e.target.files[0];
        OnSelectFile(e, isDrop);
        setFileName(file.name);
    };

    function onDrop(e) {
        e.preventDefault();
        setDragging(false);
        onSelectFile(e, true);
    };

    function onDragOver(e) {
        e.preventDefault();
        setDragging(true);
    };

    function onDragEnd() {
        setDragging(false);
    };

    function onDragLeave() {
        setDragging(false)
    };

    async function uploadFile() {
        await UploadFile(fileInput);
        if (fileInput && fileInput.current) fileInput.current.value = null;
        setFileName("");
    }

    return (
        <div className="FileUpload">
            <p className="title-field">{CAPTION}</p>
            <div
                className="route_page conversation_tools_page"
                onDragOver={onDragOver}
            >
                <label
                    onDrop={onDrop}
                    onDragOver={onDragOver}
                    onDragEnd={onDragEnd}
                    onDragLeave={onDragLeave}
                    htmlFor={HtmlFor}
                    className={`df acc upload_lbl ${fileName ? "selected " : ""
                        } ${dragging ? "dragging" : ""}`}
                >
                    {fileName ? (

                        <div className="upload_label">
                            <img className="uploadIcon" src={uploadIcon} alt="" />
                            <span className="fwc fwsb5 fs16 ">Your uploaded file </span>
                            <p className="file_name" title={fileName}>
                                {fileName}
                            </p>
                        </div>
                    ) :
                        (
                            <label htmlFor={HtmlFor}>
                                <img className="uploadIcon" src={uploadIcon} alt="" />
                                <span className="fwc fwsb5 fs16">Drag & Drop Files here </span>
                                <span className="format-type fs14">File format: {Accept}</span>
                                <span
                                    className={`fs16 primary custom_btn ${Color ? "" : "bg-primary"}`}
                                    style={{ backgroundColor: Color ? Color : "" }}
                                >Browse</span>
                                <p className="format-type fs14">Maximum size: 5MB</p>

                            </label>
                        )}

                    <input
                        accept={Accept}
                        className="dn"
                        type="file"
                        id={HtmlFor}
                        onChange={onSelectFile}
                        ref={fileInput}
                    ></input>
                    {fileName && (
                        <button
                            disabled={!fileName}
                            onClick={uploadFile}
                            className={`fs16 primary ${Color ? "" : "bg-primary"}`}
                            style={{ backgroundColor: Color ? Color : "" }}
                        >
                            {ButtonText}
                        </button>)}
                </label>

                {fileError && (
                    <p className="toast">
                        {fileError} please try again
                    </p>
                )}
            </div>
        </div>

    );
};

export default FileUpload